module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-snow-3fe66ed5.svg";